module.exports = __webpack_public_path__ + "static/media/phone-half.c6a68efb.png";